module.exports = "bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvYXNzZXRzLzg3YTNhNjJjMDYyN2U5MjViOTJkM2VkZTJmNjJiMDRmLnR0ZiI7"